<template>
    <div class="form-value">
        <div class="simple-row">
            <div class="left">
                <swb-file-upload fileGroup="file-misc" fileFor="purch" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
            </div>
        </div>
        <!--<ul class="file-area input clearfix" v-if="fileList.length > 0">-->
        <!--<li class="file-content clearfix" style="height: 200px;" :class="{'active': fileInfo.checked}" v-for="(fileInfo, index) in fileList">-->
        <!--<el-checkbox v-model="fileInfo.checked" :disabled="true"></el-checkbox>-->
        <!--<swb-file-item :trackKey="index" :fileName="fileInfo.name" :fileUuid="fileInfo.fileUuid" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileMd5="fileInfo.fileMd5" :deletable="true" :onDelete="deleteFile"></swb-file-item>-->
        <!--<el-input :title="fileInfo.name" @blur="changeDesc(index)" v-model="fileInfo.name" placeholder="文件名称不可多于30个字"></el-input>-->
        <!--</li>-->
        <!--</ul>-->
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import SwbFileUpload from './FileUpload';

    Vue.regist(SwbFileUpload);

    import SwbFileItem from './FileItem';

    Vue.regist(SwbFileItem);

    export default {
        name: 'swb-file-upload-list',
        desc: '附件上传',
        props: ['allFileList', 'selectFileUuids'],
        data: function () {
            return {
                fileList: []
            }
        },
        mounted: function () {
            let allFileList = Utils.merge([], this.allFileList) || [];
            let selectFileUuids = this.selectFileUuids || [];
            //
            for(let i = 0; i < allFileList.length; i++) {
                let fileInfo = allFileList[i];
                //
                fileInfo.checked = selectFileUuids.indexOf(fileInfo.fileUuid) >= 0;
            }
            this.fileList = Utils.merge([], allFileList);
        },
        beforeDestroy() {
            //data
            this.fileList = null;
            //props
            this.allFileList = null;
            this.selectFileUuids = null;
        },
        methods: {
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在上传文件");
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                this.theLoader.hide();
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let fileInfo = files[i];
                        let item = {
                            fileUuid: fileInfo.fileUuid,
                            name: fileInfo.fileName,
                            fileExtName: fileInfo.fileExtName,
                            fileBrowseUrl: fileInfo.fileBrowseUrl,
                            checked: true
                        };
                        self.fileList.push(item);
                    }
                    self.$emit("handle-change", self.fileList);
                }
                else {
                    this.$message.success(result.message);
                }
            },
            changeDesc: function (index) {
                let fileList = this.fileList || [];
                let fileInfo = fileList[index];
                if(fileInfo.name.length > 40) {
                    MsgBox.warning("文件名称不可多于40个字");
                    return;
                }
            },
            deleteFile: function (index) {
                this.fileList.removeAt(index.trackKey);
                return false;
            },
            getFilesResult: function () {
                let result = {
                    type: 'info'
                };
                let checkedList = [];
                let fileList = this.fileList || [];
                let fileNames = fileList.pluck('name');
                let warnFlag = false;
                let message = "";
                for(let i = 0; i < fileList.length; i++) {
                    let fileInfo = fileList[i];
                    if(Utils.isTrue(fileInfo.checked)) {
                        checkedList.push(fileInfo);
                    }
                    //
                    let index = fileNames.indexOf(fileInfo.name);
                    fileNames.splice(index, 1);
                    if(fileNames.indexOf(fileInfo.name) >= 0) {
                        warnFlag = true;
                        message = "文件名称[" + fileInfo.name + "]存在重复名称";
                        break;
                    }
                }
                if(warnFlag) {
                    MsgBox.warning(message);
                    return;
                }
                let resultData = {
                    allFileList: fileList,
                    selectFileList: checkedList
                };
                result.data = Utils.merge({}, resultData);
                return result;
            }
        }
    }
</script>
<style>
    .file-area .checked.file-item {
        border: 1px solid #00dd1c;
    }
</style>




// WEBPACK FOOTER //
// src/compo/ctrl/ComnFilesUpload.vue